var IncrementalDOM = require('incremental-dom')
var patch = IncrementalDOM.patch
var elementOpen = IncrementalDOM.elementOpen
var elementClose = IncrementalDOM.elementClose
var skip = IncrementalDOM.skip
var currentElement = IncrementalDOM.currentElement
var text = IncrementalDOM.text

var hoisted1 = ["class", "form-group"]
var hoisted2 = ["class", "checkbox-inline"]
var hoisted3 = ["type", "checkbox"]
var hoisted4 = ["class", "checkbox-inline"]
var hoisted5 = ["type", "checkbox"]
var hoisted6 = ["class", "checkbox-inline"]
var hoisted7 = ["type", "checkbox"]
var hoisted8 = ["class", "checkbox-inline"]
var hoisted9 = ["type", "checkbox"]
var hoisted10 = ["class", "form-group"]
var hoisted11 = ["for", "defaultValue"]
var hoisted12 = ["type", "text", "id", "defaultValue", "class", "form-control input-sm", "placeholder", "Default value"]
var hoisted13 = ["class", "form-group"]
var hoisted14 = ["for", "enumeration"]
var hoisted15 = ["type", "text", "id", "enumeration", "class", "form-control input-sm", "placeholder", "Enum e.g. Mr, Mrs, Ms, Miss"]
var hoisted16 = ["class", "form-group"]
var hoisted17 = ["for", "casing"]
var hoisted18 = ["id", "casing", "class", "form-control input-sm"]
var hoisted19 = ["value", ""]
var hoisted20 = ["value", "upper"]
var hoisted21 = ["value", "lower"]
var hoisted22 = ["class", "form-group"]
var hoisted23 = ["for", "match"]
var hoisted24 = ["type", "text", "id", "match", "class", "form-control input-sm", "placeholder", "Match (RegEx)"]
var __target

module.exports = function description (model) {
elementOpen("div", "8d01844e-4d56-48ef-a552-0ed29453de5a", hoisted1)
  elementOpen("div")
    elementOpen("label", "99955aa0-5f14-467f-8935-cd8e1e4a2d4e", hoisted2)
      elementOpen("input", "8e6b471b-824d-4e46-a30f-39399da6bfee", hoisted3, "checked", model.required, "onchange", function ($event) {
        var $element = this;
      model.required = this.checked})
      elementClose("input")
      text(" Required \
          ")
    elementClose("label")
    elementOpen("label", "f361a2dd-9c90-4b82-a0b0-e866866fdde5", hoisted4)
      elementOpen("input", "4237aeee-59c4-490d-acb9-e84a1bfbee3e", hoisted5, "checked", model.trim, "onchange", function ($event) {
        var $element = this;
      model.trim = this.checked})
      elementClose("input")
      text(" Trim \
          ")
    elementClose("label")
    elementOpen("label", "e00d778c-cbb9-470f-98d2-a521a20fafde", hoisted6)
      elementOpen("input", "b8dc126c-6348-4943-b4ba-17781bb16357", hoisted7, "checked", model.unique, "onchange", function ($event) {
        var $element = this;
      model.unique = this.checked})
      elementClose("input")
      text(" Unique \
          ")
    elementClose("label")
    elementOpen("label", "f4f36d3c-9e5b-4f39-be51-e04fc7e768e2", hoisted8)
      elementOpen("input", "c4b48fda-4e87-42aa-b92b-316693825bd5", hoisted9, "checked", model.index, "onchange", function ($event) {
        var $element = this;
      model.index = this.checked})
      elementClose("input")
      text(" Index \
          ")
    elementClose("label")
  elementClose("div")
elementClose("div")
elementOpen("div", "e0140ab6-ed46-4cce-b9aa-9de3c7839fd6", hoisted10)
  elementOpen("label", "69c38f26-2561-4f0f-93d1-622423911863", hoisted11)
    text("Default value")
  elementClose("label")
  elementOpen("input", "c7ae5305-9e81-45a6-a341-92eb782ab073", hoisted12, "value", model.defaultValue, "onchange", function ($event) {
    var $element = this;
  model.defaultValue = this.value})
  elementClose("input")
elementClose("div")
elementOpen("div", "e9a6dbd5-18c8-48ce-9dda-8514061a1d4b", hoisted13)
  elementOpen("label", "6fa8b26e-9e30-40b8-baed-8b34181b53b2", hoisted14)
    text("Enumeration")
  elementClose("label")
  elementOpen("input", "996cb56b-aa8f-40ff-ae36-a31902ee66f7", hoisted15, "value", model.enumeration, "onchange", function ($event) {
    var $element = this;
  model.enumeration = this.value})
  elementClose("input")
elementClose("div")
elementOpen("div", "295a3ea9-c08d-4b0a-8cb2-4136196886aa", hoisted16)
  elementOpen("label", "f54c7d51-b09c-4b29-92b3-72eaa1422019", hoisted17)
    text("Casing")
  elementClose("label")
  elementOpen("select", "ff48b34a-1337-4a6a-b944-e05645e70a47", hoisted18, "value", model.casing, "onchange", function ($event) {
    var $element = this;
  model.casing = this.value})
    elementOpen("option", "b9fb344a-3362-4cd4-8f3c-9190f902e085", hoisted19)
    elementClose("option")
    elementOpen("option", "35e53828-efe3-4f0b-be0e-47b2040eb1b6", hoisted20, "selected", model.casing === 'upper' ? 'selected' : null)
      text("Uppercase")
    elementClose("option")
    elementOpen("option", "30ad5697-5113-4e68-a9cf-5e638b76a247", hoisted21, "selected", model.casing === 'lower' ? 'selected' : null)
      text("Lowercase")
    elementClose("option")
  elementClose("select")
elementClose("div")
elementOpen("div", "c59d3d47-72e2-407f-8dc6-19897515b7d5", hoisted22)
  elementOpen("label", "2c7f37e8-49cf-4c16-b02f-1222e075ccdd", hoisted23)
    text("Match (RegEx)")
  elementClose("label")
  elementOpen("input", "f4447abf-d93d-47aa-80e4-f23092042be3", hoisted24, "value", model.match, "onchange", function ($event) {
    var $element = this;
  model.match = this.value})
  elementClose("input")
elementClose("div")
}
